<div class="container mt-4" dir="rtl">
  <h3>مدیریت کاربران</h3>

  <!-- Add user Button -->
  <div class="d-flex justify-content-end mb-3">
    <button class="btn btn-primary" (click)="openModal()">
      افزودن کاربر
    </button>
  </div>

 <!-- 🟪 نسخه موبایل: نمایش کارتی -->
<div class="d-block d-md-none">
  <div *ngFor="let item of userList" class="card mb-3 shadow-sm">
    <div class="card-body">
      <!-- <h5 class="card-title fw-bold">{{ item.name }}</h5> -->
      <p><strong>نام کاربری:</strong> {{ item.userName }}</p>
      <p><strong>ایمیل:</strong> {{ item.email }}</p>
      <p><strong>تلفن:</strong> {{ item.phoneNumber }}</p>
      <p><strong>نقش:</strong> {{ item.role }}</p>

      <div class="mt-2 text-end">
        <button class="btn btn-warning btn-sm me-2" (click)="openEditModal(item)">ویرایش</button>
        <button class="btn btn-danger btn-sm" (click)="delete(item.id)">حذف</button>
      </div>
    </div>
  </div>
</div>

<!-- 🟪 نسخه دسکتاپ: نمایش جدولی -->
<div class="table-responsive d-none d-md-block">
  <table class="table table-bordered text-end custom-table">
    <thead class="custom-thead">
      <tr>
        <th>نام کاربری</th>
        <th>ایمیل</th>
        <th>تلفن</th>
        <th>نقش</th>
        <th>اقدام</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of userList">
        <td>{{ item.userName }}</td>
        <td>{{ item.email }}</td>
        <td>{{ item.phoneNumber }}</td>
        <td>{{ item.role }}</td>
        <td>
          <button class="btn btn-warning btn-sm me-2" (click)="openEditModal(item)">ویرایش</button>
          <button class="btn btn-danger btn-sm" (click)="delete(item.id)">حذف</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>


  <!-- Modal -->
  <div class="modal fade" #userModal id="userModal" tabindex="-1" aria-labelledby="userModalLabel" aria-hidden="true">

    <!-- <div class="modal fade" id="userModal" tabindex="-1" aria-labelledby="userModalLabel" aria-hidden="true"> -->
    <div class="modal-dialog">
      <div class="modal-content" dir="rtl">
        <div class="modal-header">
          <h5 class="modal-title" id="userModalLabel">
            {{ userObj.id ? 'ویرایش کاربر' : 'افزودن کاربر' }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()"
            aria-label="بستن"></button>
        </div>


        <div class="modal-body">
          <form id="userForm">
            <div class="row g-3">

              <div class="col-md-6">
                <label class="form-label">نام کاربری</label>
                <input type="text" [(ngModel)]="userObj.userName" name="userName" class="form-control"
                  placeholder="نام کاربری">
              </div>

              <div class="col-md-6">
                <label class="form-label">ایمیل</label>
                <input type="email" [(ngModel)]="userObj.email" name="email" class="form-control" placeholder="ایمیل">
              </div>

              <div class="col-md-6">
                <label class="form-label">شماره تلفن</label>
                <input type="text" [(ngModel)]="userObj.phoneNumber" name="phoneNumber" class="form-control"
                  placeholder="مثلاً 09121234567">
              </div>
              <div class="col-md-6">
                <label class="form-label">رول </label>
                <input type="text" [(ngModel)]="userObj.role" name="role" class="form-control"
                  placeholder="User ">
              </div>


            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
          <button type="button" (click)="onSave()" class="btn btn-success">
            {{ userObj.id ? 'ذخیره تغییرات' : 'افزودن' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
